import { ResultTypeAmount } from "../reducers/mainReducer";

export const TOGGLE_PERSONAL_INFO_POPUP = 'TOGGLE_PERSONAL_INFO_POPUP';
export const TOGGLE_COMMUNITY_POPUP = 'TOGGLE_COMMUNITY_POPUP';
export const SET_RESULT_TYPE_AMOUNT = "SET_RESULT_TYPE_AMOUNT";
export const SET_SEARCH_FILTER = "SET_SEARCH_FILTER";
export const SET_SIDEBAR_ROUTE_DATA = "SET_SIDEBAR_ROUTE_DATA";
export const SET_CURRENT_COURSE = "SET_CURRENT_COURSE";
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const SET_CURRENT_COMMUNITY_ID = "SET_CURRENT_COMMUNITY_ID"
export const SET_CURRENT_EVENT = "SET_CURRENT_EVENT"
export const SET_CURRENT_PARTICIPANTS= "SET_CURRENT_PARTICIPANTS"

export const SET_CURRENT_CAMPUS= "SET_CURRENT_CAMPUS"

export const togglePersonalInfoPopup = (value: boolean) => {
    return { type: TOGGLE_PERSONAL_INFO_POPUP, value }
}

export const toggleCommunityPopup = (value: boolean) => {
    return { type: TOGGLE_COMMUNITY_POPUP, value }
}

export const setResultTypeAmount = (value: ResultTypeAmount[]) => {
    return { type: SET_RESULT_TYPE_AMOUNT, value };
}

export const setSearchFilter = (value: string | undefined) => {
    return { type: SET_SEARCH_FILTER, value };
}

export const setSidebarRouteData = (value: any) => {
    return { type: SET_SIDEBAR_ROUTE_DATA, value }
}

export const setCurrentCourse = (value: any) => {
    return { type: SET_CURRENT_COURSE, value }
}

export const setCurrentEvent = (value: any) => {
    return { type: SET_CURRENT_EVENT, value }
}

export const setCurrentParticipants = (value: any) => {
    return { type: SET_CURRENT_PARTICIPANTS, value }
}

export const setCurrentPage = (value: string) => {
    return { type: SET_CURRENT_PAGE, value }
}

export const setCurrentCommunityId = (value: any) => {
    return { type: SET_CURRENT_COMMUNITY_ID, value }
}

